module.exports = __webpack_public_path__ + "static/media/dsv.377ec8ab.png";